export default {
  request: {
    title: {
      notes: 'Title in dialog to request downloading high-resolution data',
      message: 'Fetch high-resolution data',
    },
    startTime: {
      notes: 'Start time field in form requesting high-resolution data',
      message: 'Start time',
      validation: {
        maxAge: {
          notes: 'Validation message when trying to fetch to old data',
          message:
            'Please select a more recent date. Data is only available for the last 3 months.',
        },
        minAge: {
          notes: 'Validation message when trying to fetch to fresh data',
          message:
            "Please select an earlier time. Recent data may still be processing and isn't available yet.",
        },
      },
    },
    duration: {
      notes: 'Duration field in form requesting high-resolution data',
      message: 'Duration',
      setMaxDuration: {
        notes: 'Label on action to set duration to max limit',
        message: 'Set to 10 min',
      },
    },
    successToast: {
      notes:
        'Toast message when successfully submitting request to fetch high resolution data',
      message:
        'Download request submitted! You can continue working while we prepare your data.',
    },
  },
};
